<template>
  <div class="page">
    <div class="main-left">
      <div
        class="left-item"
        :class="type === 'user' ? 'active' : ''"
        @click="tabChange('user')"
        title="基础资料"
      >
        <i class="el-icon-tickets"></i>
        <span>基础资料</span>
      </div>
      <div
        class="left-item"
        :class="type === 'user' ? '' : 'active'"
        @click="tabChange('safe')"
        title="账户安全"
      >
        <i class="el-icon-service"></i>
        <span>账户安全</span>
      </div>
    </div>
    <div class="main-right">
      <div class="right-item" v-show="type==='user'">
        <p class="right-title">
          <span @click="tabChange('index')" class="pointer">首页</span><span @click="tabChange('user')" class="pointer">&nbsp;>&nbsp;个人中心&nbsp;>&nbsp;</span>用户信息
        </p>
        <div class="right-content">
          <el-form label-width="120px">
            <!-- 没有手机号的情况展示 -->
            <div v-if="!userInfo.mobile">
              <el-form-item label="头像">
                <div class="imageBox">
                  <img :src="userInfo.avatarUrl?userInfo.avatarUrl:avatarUrl" />
                </div>
              </el-form-item>
              <el-form-item label="昵称">
                <span>{{userInfo.nickname}}</span>
              </el-form-item>
              <div style="padding-left:3.1rem;">
                您尚未绑定手机号，为避免信息不全，请您绑定手机号信息
                <el-button type="text" @click="bindMobile" class="textMod">去绑定</el-button>
              </div>
            </div>
            <!-- 有手机号的情况展示 -->
            <div v-if="userInfo.mobile">
              <el-form-item label="头像">
                <div
                  class="imageBox"
                  @click="showAvata = true"
                  @mouseenter="moveIn"
                  @mouseleave="moveOut"
                >
                  <div class="default" v-if="modify">修改头像</div>
                  <img :src="userInfo.avatarUrl?userInfo.avatarUrl:avatarUrl" />
                </div>
              </el-form-item>
              <el-form-item label="用户名" style="line-height:0;">
                <span v-if="!isUserName">{{userInfo.userName2}}</span>
                <el-input type="text" v-model="userInfo.userName" v-else style="width:220px" />
                <el-button type="text" @click="isUserName = true" class="textMod" v-if="!isUserName">修改</el-button>
                <el-button type="text" @click="setUserName" class="textMod" v-else>保存</el-button>
                <div v-if="isUserName" style="color:#999;font-size:12px;line-height:18px;">以字母开头，可输入6~10位字母+数字，不可输入特殊符号！</div>
              </el-form-item>
              <el-form-item label="昵称">
                <span v-if="!m_name">{{userInfo.nikeName}}</span>
                <el-input type="text" v-model="userInfo.nikeName" v-else style="width:220px" />
                <el-button type="text" @click="m_name = true" class="textMod">修改</el-button>
              </el-form-item>
              <el-form-item label="性别">
                <el-radio label="1" v-model="userInfo.gender">男</el-radio>
                <el-radio label="2" v-model="userInfo.gender">女</el-radio>
              </el-form-item>
              <el-form-item label="生日">
                <span v-if="!m_birth">{{userInfo.birthday}}</span>
                <el-date-picker
                  v-model="userInfo.birthday"
                  v-else
                  type="date"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                ></el-date-picker>
                <el-button type="text" @click="m_birth = true" class="textMod">修改</el-button>
              </el-form-item>
            </div>
          </el-form>
          <el-button @click="save" class="saveButton" type="primary" v-if="userInfo.mobile">保存</el-button>
        </div>
      </div>
      <div class="right-item" v-show="type==='safe'">
        <p class="right-title">
          <span @click="tabChange('index')" class="pointer">首页</span><span @click="tabChange('user')" class="pointer">&nbsp;>&nbsp;个人中心&nbsp;>&nbsp;</span>账户信息
        </p>
        <div class="right-content">
          <el-form label-width="120px">
            <el-form-item label="修改密码" v-if="user_password === 1">
              <span>******</span>
              <router-link to="/form/changePassword">
                <el-button type="primary" size="small" class="setBtn">修改</el-button>
              </router-link>
            </el-form-item>
            <el-form-item label="设置密码" v-else>
              <span>您还没有设置密码</span>
              <router-link to="/form/setPassword">
                <el-button type="primary" size="small" class="setBtn">设置</el-button>
              </router-link>
            </el-form-item>
            <el-form-item label="手机号码">
              <span>{{userInfo.mobile}}</span>
              <router-link :to="{path: '/form/changeMobile', query: {oldMobile: userInfo.mobile}}">
                <el-button type="primary" size="small" class="setBtn">修改</el-button>
              </router-link>
            </el-form-item>
            <el-form-item label="绑定邮箱">
              <router-link to="/form/setMailbox">
                <span>{{userInfo.email}}</span>
                <el-button type="primary" size="small" class="setBtn">修改</el-button>
              </router-link>
            </el-form-item>
            <el-form-item label="绑定第三方">
              <span style="margin-right:20px;color:#999;">QQ</span>
              <span style="margin-right:20px;color:#999;">微信</span>
              <span style="margin-right:20px;color:#999;">微博</span>
              <el-button
                type="primary"
                size="small"
                class="setBtn"
                @click="tabChange('thirdParty')"
              >绑定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="right-item" v-show="type==='thirdParty'">
        <p class="right-title">
          <span @click="tabChange('index')" class="pointer">首页</span>
          <span @click="tabChange('user')" class="pointer">&nbsp;>&nbsp;个人中心&nbsp;>&nbsp;</span>
          <span @click="tabChange('safe')" class="pointer">账户信息&nbsp;>&nbsp;</span>绑定第三方账户
        </p>
        <div class="right-content">
          <el-form label-width="90px" class="thirdParty">
            <el-form-item label>
              <img src="@/assets/login/bright_weixin.png" alt />
              <span v-if="isWx">绑定微信账号，使用微信账号便捷登录</span>
              <span v-else>已绑定微信账号，可使用微信账号便捷登录</span>
              <el-button type="primary" size="small" class="setBtn" @click="binding(1)">{{isWx?'绑定':'修改'}}</el-button>
            </el-form-item>
            <el-form-item label>
              <img src="@/assets/login/bright_weibo.png" alt />
              <span v-if="isWb">绑定微博账号，使用微博账号便捷登录</span>
              <span v-else>已绑定微博账号，可使用微博账号便捷登录</span>
              <el-button type="primary" size="small" class="setBtn" @click="binding(3)">{{isWb?'绑定':'修改'}}</el-button>
            </el-form-item>
            <el-form-item label>
              <img src="@/assets/login/bright_qq.png" alt />
              <span style="color:#999;">绑定QQ账号，使用QQ账号便捷登录</span>
              <!-- <el-button type="primary" size="small" class="setBtn" @click="binding(2)">绑定</el-button> -->
              <el-button type="info" size="small" class="setBtn" @click="binding(2)" disabled>绑定</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showAvata" title="修改头像" width="30%">
      <div class="uploadBox">
        <div class="upload">
          <el-upload
            class="avatar-uploader"
            action="/api/file/upload"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="userInfo.avatarUrl" :src="userInfo.avatarUrl" class="avatar" />
            <div v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <p class="upload-title">添加图片</p>
              <p>只支持PNG/JPG/GIF，GIF不能动画化</p>
              <p>大小不超过5M</p>
              <p>建议尺寸为240*240</p>
            </div>
          </el-upload>
        </div>
        <div class="perview">
          <img :src="userInfo.avatarUrl?userInfo.avatarUrl:avatarUrl" alt />
          <p>头像预览</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAvata = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showBindMobile" title="绑定手机号" width="30%">
      <div style="text-align: center;font-size:0.65rem;">需绑定手机号才可查看，是否绑定?</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showBindMobile = false">取 消</el-button>
        <el-button type="primary" @click="bindMobile">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import uploadMixins from '@/mixins/uploadMixins';
import { mapGetters, mapActions } from 'vuex';
import { USER_SIGNIN } from '@/store/auth';
import { formApi, authApi } from '@/api';
import cryptoPhp from '../../libs/common/cryptoPhp' // 加密解密文件
import store from '@/store'
export default {
  mixins: [uploadMixins],
  data() {
    return {
      type: this.$route.query.type ? this.$route.query.type : 'user',
      userInfo: {},
      user_password: JSON.parse(window.localStorage.id_user).isSetPassword,
      isUserName: false, // 修改用户名
      m_name: false,
      m_birth: false,
      showAvata: false,
      showBindMobile: false,
      avatarUrl: require('@/assets/defaultLogo.png'),
      modify: false,
      isWx: true,
      isWb: true
    };
  },
  watch: {
    $route(to, from) {
      this.type = to.query.type;
      if (!to.query.type) {
        this.type = 'user';
      }
      if ((to.query.type === 'safe' || to.query.type === 'index') && !this.userInfo.mobile) {
        this.showBindMobile = true;
        this.type = 'user';
        this.$router.push({
          path: '/index?type=user'
        });
      }
    }
  },
  activated() {
    this.userInfo_data();
  },
  mounted() {
    this.userInfo_data();
  },
  methods: {
    // 绑定第三方
    binding(type) {
      if (type === 1) {
        // 微信
        window.localStorage.bindType = 'wx';
        this.wxState(1).then(data => {
          let url = encodeURI('https://id.juranguanjia.com/bind/wx');
          window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wxf386957290ae6e88&redirect_uri=${url}&scope=snsapi_login&state=${this.state}&response_type=code#wechat_redirect`;
        });
      } else if (type === 2) {
        // QQ
        this.$message.error('开发中，请敬请期待！');
        // window.localStorage.bindType = 'QQ'
        // this.wxState(2).then((data) => {
        //   let url = encodeURI('https://id.juranguanjia.com/bind/qq')
        //   window.location.href = `https://graph.qq.com/oauth2.0/authorize?client_id=101575678&redirect_uri=${url}&state=${this.state}&response_type=code`
        // })
      } else {
        // 微博
        window.localStorage.bindType = 'wb';
        this.wxState(3).then(data => {
          let url = encodeURI('https://id.juranguanjia.com/bind/wb');
          window.location.href = `https://api.weibo.com/oauth2/authorize?client_id=403096172&response_type=code&redirect_uri=${url}`;
        });
      }
    },
    // 获取state
    async wxState(type) {
      let params = {
        thirdLoginType: type
      };
      try {
        let data = (await authApi.getState(params)).data;
        if (data.statusCode === 200) {
          this.state = data.data;
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    ...mapActions([USER_SIGNIN]),
    // 鼠标移入头像
    moveIn() {
      this.modify = true;
    },
    // 鼠标移出头像
    moveOut() {
      this.modify = false;
    },
    // 用户信息
    async userInfo_data() {
      try {
        let data = (await formApi.userInfo()).data;
        if (data.statusCode === 200) {
          data.data.gender = String(data.data.gender);
          this.userInfo = data.data;
          this.userInfo.userName2 = this.userInfo.userName
        }
      } catch (err) {
        this.userInfo = JSON.parse(window.localStorage.id_user)
        console.log(this.userInfo)
        console.error(err);
      } finally {
      }
    },
    handleAvatarSuccess(a) {
      this.$message({
        type: 'success',
        message: '上传成功'
      });
      this.userInfo.avatarUrl = a.data;
    },
    tabChange(type) {
      if (type === 'index') {
        if (store.state.Auth.jrwyToken) {
          let jrwyToken = cryptoPhp.Encrypt(store.state.Auth.jrwyToken)
          let backUrl = `${process.env.VUE_APP_AUTH_URL}?jrwyToken=${encodeURIComponent(jrwyToken)}`
          window.location.href = encodeURI(backUrl)
        } else {
          window.location.href = `${process.env.VUE_APP_AUTH_URL}`
        }
        return
      }
      if (type !== this.$route.query.type) {
        this.$router.push({
          path: '/index?type=' + type
        });
      }
      if (type === 'thirdParty') {
        this.getSsobindinfo();
      }
    },
    // 获取第三方绑定信息
    // 1:微信，2：QQ，3：微博
    async getSsobindinfo() {
      try {
        let data = (await formApi.ssobindinfo()).data;
        if (data.statusCode === 200) {
          console.log(data.data);
          if (data.data.length !== 0) {
            data.data.map(item => {
              if (item.thirdLoginType === 1) {
                this.isWx = false
              } else if (item.thirdLoginType === 2) {

              } else if (item.thirdLoginType === 3) {
                this.isWb = false
              }
            })
          } else {
            this.isWx = true
            this.isWb = true
          }
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    },
    // 去绑定手机号
    bindMobile() {
      window.localStorage.bindMobileUrl = 'index'
      window.localStorage.bindMobile = 0
      history.go(0)
    },
    changeAvata() {},
    async setUserName() {
      var user = /^[a-zA-Z]\w{5,9}$/;
      console.log(this.userInfo.userName, this.userInfo.userName)
      if (this.userInfo.userName === this.userInfo.userName2) {
        this.isUserName = false
        return false
      }
      if (user.test(this.userInfo.userName)) {
        try {
          let params = {
            userName: this.userInfo.userName,
          };
          let data = (await formApi.setUserName(params)).data;
          if (data.statusCode === 200) {
            this.$message.success('修改成功!');
            this.userInfo_data()
            this.isUserName = false
          }
        } catch (err) {
          console.error(err);
        } finally {
        }
      } else {
        this.$message.error('以字母开头，可输入6~10位字母+数字，不可输入特殊符号！');
      }
    },
    // 修改信息接口
    async save() {
      try {
        let params = {
          avatarUrl: this.userInfo.avatarUrl,
          birthday: this.userInfo.birthday,
          gender: this.userInfo.gender,
          nickName: this.userInfo.nikeName
        };
        let data = (await formApi.setName(params)).data;
        if (data.statusCode === 200) {
          this.m_name = false;
          this.m_birth = false;
          this.showAvata = false;
          this.USER_SIGNIN(params);
          this.$message.success('修改成功!');
        }
      } catch (err) {
        console.error(err);
      } finally {
      }
    }
  },
  computed: {
    ...mapGetters(['user'])
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/styles/common.less";
.page {
  width: 990 / @h;
  // height: 31.8rem !important;
  display: flex;
  justify-content: flex-start;
  .main-left {
    width: 5rem;
    background: rgba(250, 250, 250, 1);
    height: 100%;
    text-align: center;
    .left-item {
      width: 100%;
      height: 4rem;
      font-weight: 400;
      color: rgba(184, 197, 206, 1);
      font-size: 0.5rem;
      padding-top: 1.2rem;
      i {
        display: block;
        text-align: center;
        font-size: 1.7rem;
      }
      span {
        margin-top: 0.2rem;
        display: block;
      }
    }
    .active {
      background: white;
      font-weight: 400;
      font-size: 0.5rem;
      color: rgba(238, 142, 56, 1);
    }
  }
  .main-right {
    width: 32rem;
    height: 100%;
    .right-title {
      height: 2.5rem;
      line-height: 2.5rem;
      font-size: 0.56rem;
      color: rgba(51, 51, 51, 0.7);
      font-weight: 400;
      border-bottom: 1px solid #f5f5f5;
      padding-left: 1rem;
    }
    .right-content {
      padding-top: 2rem;
      font-size: 14px !important;
      .imageBox {
        width: 5rem;
        height: 5rem;
        border-radius: 50%;
        overflow: hidden;
        position: relative;
        cursor: pointer;
        .default {
          width: 5rem;
          height: 5rem;
          position: absolute;
          top: 0;
          left: 0;
          line-height: 5rem;
          text-align: center;
          font-size: 0.7rem;
          color: #ffffff;
          background: rgba(0, 0, 0, 30%);
        }
        img {
          width: 100%;
        }
      }
      .setBtn {
        margin-left: 1rem;
        float: right;
      }
      .textMod {
        margin-left: 1rem;
      }
    }
  }
  .saveButton {
    margin: 150px auto;
    display: block;
  }

  //弹框样式
  .uploadBox {
    width: 18rem;
    height: 13rem;
    overflow: hidden;
    margin: 0 auto;
    .upload {
      float: left;
      width: 11rem;
      height: 11rem;
      background: rgba(244, 244, 244, 1);
      margin-right: 1rem;
      position: relative;
      .avatar-uploader {
        height: 100%;
        width: 100%;
        .el-upload--text {
          .avatar {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          i {
            display: block;
            width: 1.2rem;
            height: 1.2rem;
            line-height: 1.2rem;
            text-align: center;
            color: white;
            background: #ee8e38;
            border-radius: 0.6rem;
            margin: 0 auto;
            margin-top: 3.3rem;
            margin-bottom: 0.5rem;
          }
          .upload-title {
            margin-bottom: 0.5rem;
          }
          p {
            height: 0.8rem;
            font-size: 0.52rem;
            font-family: SourceHanSansCN-Normal;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
          }
        }
      }
    }
    .perview {
      float: left;
      width: 4.5rem;
      img {
        width: 4.4rem;
        display: block;
        height: 4.4rem;
        border-radius: 2.2rem;
        overflow: hidden;
        margin: 0 auto;
      }
      p {
        text-align: center;
        font-size: 0.52rem;
        font-family: SourceHanSansCN-Normal;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        margin-top: 0.5rem;
      }
    }
  }
  // 小手
  .pointer {
    cursor: pointer !important;
  }
  // 三方绑定
  .thirdParty {
    img {
      margin-right: 20px;
    }
  }
}
@media screen and (max-width: 750px) {
  .page {
    width: 90%;
    .main-left {
      .left-item {
        span {
          display: none;
        }
      }
    }
    .main-right {
      @{deep} .el-form-item__label {
        width: 80px !important;
      }
      // @{deep} .el-form-item__content{
      //   width: 120px!important;
      // }
    }
    @{deep} .el-dialog {
      width: 100% !important;
    }
    .el-button--small {
      padding: 9px 20px !important;
    }
    .setBtn {
      margin: 0 1rem 0 0 !important;
    }
  }
}
</style>
